
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { api, getAuthHeaders } from '../utils/api';

// Async thunk for fetching MFA status
// Thunk to fetch MFA status
export const fetchMfaStatus = createAsyncThunk(
	'mfa/fetchStatus',
	async (_, { rejectWithValue }) => {
		try {
			const response = await api.get('users/me/mfa/status', { headers: getAuthHeaders() });
			return response.data;
		} catch (error) {
			return rejectWithValue(error.response?.data || error.message);
		}
	}
);
// Thunk to disable MFA
export const disableMfa = createAsyncThunk(
	'mfa/disable',
	async (_, { rejectWithValue }) => {
		try {
			const response = await api.post('/users/me/mfa/disable', {}, { headers: getAuthHeaders() });
			return response.data;
		} catch (error) {
			return rejectWithValue(error.response?.data || error.message);
		}
	}
);
// Thunk to enable MFA
export const enableMfa = createAsyncThunk(
	'mfa/enable',
	async (_, { rejectWithValue }) => {
		try {
			const response = await api.post('/users/me/mfa/enable', {}, { headers: getAuthHeaders() });
			return response.data;
		} catch (error) {
			return rejectWithValue(error.response?.data || error.message);
		}
	}
);

const mfaSlice = createSlice({
	name: 'mfa',
	initialState: {
		status: null,
		loading: false,
		error: null,
		enableLoading: false,
		enableError: null,
		enableSuccess: false,
	},
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(fetchMfaStatus.pending, (state) => {
				state.loading = true;
				state.error = null;
			})
			.addCase(fetchMfaStatus.fulfilled, (state, action) => {
				state.loading = false;
				// Normalize the payload to always have mfaEnabled and hasEnrollments
				if (typeof action.payload === 'object' && action.payload !== null) {
					if ('mfaEnabled' in action.payload) {
						// Check both mfaEnabled and hasEnrollments
						const isMfaEnabled = action.payload.mfaEnabled === true && action.payload.hasEnrollments === true;
						state.status = { ...action.payload, mfaEnabled: isMfaEnabled };
					} else if ('enabled' in action.payload) {
						state.status = { mfaEnabled: action.payload.enabled };
					} else if ('success' in action.payload && typeof action.payload.success === 'boolean') {
						// fallback: treat success as enabled
						state.status = { mfaEnabled: !!action.payload.success };
					} else {
						state.status = { mfaEnabled: false };
					}
				} else {
					state.status = { mfaEnabled: false };
				}
			})
			   .addCase(fetchMfaStatus.rejected, (state, action) => {
					   state.loading = false;
					   state.error = action.payload;
				   })
				   // Enable MFA
				   .addCase(enableMfa.pending, (state) => {
					   state.enableLoading = true;
					   state.enableError = null;
					   state.enableSuccess = false;
				   })
				   .addCase(enableMfa.fulfilled, (state, action) => {
					   state.enableLoading = false;
					   state.enableSuccess = true;
					   // Optionally update status if API returns new status
					   if (action.payload) {
						   state.status = action.payload;
					   }
				   })
				   .addCase(enableMfa.rejected, (state, action) => {
					   state.enableLoading = false;
					   state.enableError = action.payload;
					   state.enableSuccess = false;
				   })
				   // Disable MFA
				   .addCase(disableMfa.pending, (state) => {
					   state.enableLoading = true;
					   state.enableError = null;
					   state.enableSuccess = false;
				   })
				   .addCase(disableMfa.fulfilled, (state, action) => {
					   state.enableLoading = false;
					   state.enableSuccess = true;
					   if (action.payload) {
						   state.status = action.payload;
					   }
				   })
				   .addCase(disableMfa.rejected, (state, action) => {
					   state.enableLoading = false;
					   state.enableError = action.payload;
					   state.enableSuccess = false;
				   });
	},
});

export default mfaSlice.reducer;
